import { Component, OnInit } from '@angular/core';
import { SectionMenuComponent } from './section-menu.component';

@Component({
  moduleId: module.id,
  selector: 'section-menu-ca',
  templateUrl: './section-menu-ca.component.html',
})
export class SectionMenuCAComponent extends SectionMenuComponent implements OnInit {}
